// extracted by mini-css-extract-plugin
export default {"amount":"amount_amount__ITngR"};